import { ConfigFn } from '@config/types'

const config = (({ deploymentEnv }) =>
  ({
    onboardingUrl:
      deploymentEnv === 'prod'
        ? 'https://link.blick.ch/manage/6ma/blickplus-onboarding'
        : 'https://link-ssr.stg.blick.ch/manage/6mg/blickplus-onboarding',
    recommendationWidgetId: 'e71ec500c4815f226b3f4c580776cdb8399c6038',
    targetElementId: 'cx-recommendations-target',
  }) as const) satisfies ConfigFn

export default config
